import { ListItem, ListItemText, Stack } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

import { DiscList } from "components/common/DiscList/DiscList";
import {
  SDK_DOCS_URL
} from "config/constants";
import { HelpMessage } from "new-components/helpMessage/HelpMessage";
import { Typography } from "new-components/typography/Typography";

export function NotUsedDetectorsYetMessage() {
  return (
    <Stack
      className="m-0"
      spacing="auto"
      sx={{
        borderBottom: "1px solid #CED0D1",
        height: "241px",
        padding: "20px"
      }}
    >
      <Typography fontWeight="semibold">
        Ready to use your Groundlight detectors in a Python application?
      </Typography>

      <DiscList>
        <ListItem>
          <ListItemText
            primary={
              <>
                Review our{" "}
                <Link
                  className="font-semibold text-primary-dark no-underline"
                  to={SDK_DOCS_URL}
                  target="_blank"
                >
                  docs
                </Link>{" "}
                to learn more about how to get started.
              </>
            }
          />
        </ListItem>
      </DiscList>

      <Typography fontWeight="semibold">
        Need some help?
      </Typography>

      <DiscList>
        <ListItem>
          <ListItemText
            primary={
              <HelpMessage topic="with any questions about how to integrate Groundlight into your application." />
            }
          />
        </ListItem>
      </DiscList>
    </Stack>
  );
}
